import React from 'react';
import ResetPasswordContainer from '../../components/auth/resetPasswordContainer';

const ResetPassword = () => {
  return <ResetPasswordContainer />;
}

export default ResetPassword;
